"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = Card;
exports.CardHeader = CardHeader;
exports.CardFooter = CardFooter;
exports.CardTitle = CardTitle;
exports.CardAction = CardAction;
exports.CardDescription = CardDescription;
exports.CardContent = CardContent;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const cn_1 = require("cn");
function Card({ className, ...props }) {
    return ((0, jsx_runtime_1.jsx)("div", { "data-slot": "card", className: (0, cn_1.cn)('flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm', className), ...props }));
}
function CardHeader({ className, ...props }) {
    return ((0, jsx_runtime_1.jsx)("div", { "data-slot": "card-header", className: (0, cn_1.cn)('@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6', className), ...props }));
}
function CardTitle({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "card-title", className: (0, cn_1.cn)('leading-none font-semibold', className), ...props });
}
function CardDescription({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "card-description", className: (0, cn_1.cn)('text-sm text-muted-foreground', className), ...props });
}
function CardAction({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "card-action", className: (0, cn_1.cn)('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className), ...props });
}
function CardContent({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "card-content", className: (0, cn_1.cn)('px-6', className), ...props });
}
function CardFooter({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("div", { "data-slot": "card-footer", className: (0, cn_1.cn)('flex items-center px-6 [.border-t]:pt-6', className), ...props });
}
